export default "__VITE_ASSET__d52748e3__"